<template>
    <div class="grid-item">
        <div class="vertical-spacer"></div>
        <h1 data-cy="404" class="h800 center-align-text mt-6">404</h1>
        <p class="h300 center-align-text mt-2 mb-6">
            {{ t("default.notFound") }}
        </p>
        <div class="vertical-spacer"></div>
    </div>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>
